import React from "react";
import "./loadingspinner.css";
import PropTypes from "prop-types";

const LoadingSpinner = ({ totalprogress }) => {
  return (
    <>
      <div id="cover-spin">
        {totalprogress ? (
          <p>Uploaded {totalprogress}%</p>
        ) : totalprogress === 0 ? (
          <p>Verifying and checking...</p>
        ) : null}
      </div>
    </>
  );
};

LoadingSpinner.propTypes = {
  totalprogress: PropTypes.number,
};
export default LoadingSpinner;
